import { ICON_MAP } from '@act/storybook';
import { useAppNavigation } from 'react-components/app/routing/routes';

interface AdminTool {
  permission: string;
  condition: boolean;
  onClick: () => void;
  icon: keyof typeof ICON_MAP;
  text: string;
  tabId: string;
}

export const useAdminTools = (): AdminTool[] => {
  const navigate = useAppNavigation();

  return [
    {
      permission: 'CAN_ACCESS_ADMIN_TOOLS',
      condition: true,
      onClick: () => navigate.toUserCreation(),
      icon: 'UserPlus',
      text: 'User Administration',
      tabId: 'userAdministration',
    },
    {
      permission: 'CAN_ACCESS_ADMIN_TOOLS',
      condition: true,
      onClick: () => navigate.toCustomerView(),
      icon: 'User',
      text: 'Customers',
      tabId: 'customers',
    },
    {
      permission: 'CAN_ACCESS_ADMIN_TOOLS',
      condition: true,
      onClick: () => navigate.toTeamsManagement(),
      icon: 'UsersThree',
      text: 'Teams Management',
      tabId: 'teamsManagement',
    },
    {
      permission: 'CAN_ACCESS_ADMIN_TOOLS',
      condition: true,
      onClick: () => navigate.toPhoneNumberManagement(),
      icon: 'AddressBook',
      text: 'Phone Number Management',
      tabId: 'phoneNumberManagement',
    },
    {
      permission: 'CAN_ACCESS_ADMIN_TOOLS',
      condition: true,
      onClick: () => navigate.toSurveys(),
      icon: 'Note',
      text: 'Surveys',
      tabId: 'surveys',
    },
    {
      permission: 'CAN_ACCESS_ADMIN_TOOLS',
      condition: true,
      onClick: () => navigate.toAllMessageCategories(),
      icon: 'ChatDots',
      text: 'Message Templates',
      tabId: 'messageTemplates',
    },
    {
      permission: 'CAN_ACCESS_ADMIN_TOOLS',
      condition: true,
      onClick: () => navigate.toNeedsContent(),
      icon: 'HandHeart',
      text: 'Needs Content',
      tabId: 'needsContent',
    },
  ];
};

export default useAdminTools;
